import FontAwesome5 from '@expo/vector-icons/FontAwesome5';
import {
  responsiveFontSize,
  useResponsiveFontSize,
  useResponsiveHeight,
} from '@/components/Util/reactResponsiveDimensions';
import { Platform, StyleSheet, View } from 'react-native';
import colors from '@/config/colors';
import { PressableNeolexon } from '@/components/PressableNeolexon';

const icons = [
  { id: 1, name: 'thumbs-up', onPress: 'onThumbsUp', color: 'primary' },
  { id: 2, name: 'thumbs-up', onPress: 'onThumbs', color: 'gold' },
  { id: 3, name: 'thumbs-down', onPress: 'onThumbsDown', color: 'red' },
];

const gap = 8;
export function SpeakingFeedback({
  onThumbsUp,
  onThumbs,
  onThumbsDown,
  isRecording,
  selectedPerformance,
}) {
  const iconSize = useResponsiveFontSize(2.6);
  const marginVertical = useResponsiveHeight(1.1);

  const styles = StyleSheet.create({
    container: {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      marginVertical,
      paddingHorizontal: gap / -2,
    },
    btn: {
      marginHorizontal: gap / 2,
      width: responsiveFontSize(6.2),
      height: responsiveFontSize(6.2),
      borderRadius: Platform.OS === 'web' ? '50%' : 50,
      justifyContent: 'center',
      alignItems: 'center',
    },
    bgPrimary: {
      backgroundColor: colors.primary,
    },
    bgGold: {
      backgroundColor: colors.gold,
    },
    bgRed: {
      backgroundColor: colors.red,
    },
  });

  const onPressFunctions = {
    onThumbsUp,
    onThumbs,
    onThumbsDown,
  };

  const iconsColor = {
    primary: styles.bgPrimary,
    gold: styles.bgGold,
    red: styles.bgRed,
  };

  const FeedbackComponents = () => {
    return icons.map((icon) => {
      const onIconPress = onPressFunctions[icon.onPress];
      let bgColor = iconsColor[icon.color];
      if (icon.color === 'gold') {
        bgColor = { ...bgColor, transform: [{ rotate: '90deg' }] };
      }
      let opacityChange = false;
      if (selectedPerformance !== 'none') {
        opacityChange = true;
      }
      if (icon.color === 'primary' && selectedPerformance === 'correct') {
        opacityChange = false;
      }
      if (icon.color === 'gold' && selectedPerformance === 'almost') {
        opacityChange = false;
      }
      if (icon.color === 'red' && selectedPerformance === 'wrong') {
        opacityChange = false;
      }
      const dynamicStyle = { opacity: isRecording || opacityChange ? 0.3 : 1 };
      return (
        <PressableNeolexon
          style={[styles.btn, bgColor, dynamicStyle]}
          key={icon.id}
          onPress={onIconPress}
          disabled={isRecording || selectedPerformance !== 'none'}
        >
          <FontAwesome5 name={icon.name} color={colors.white} size={iconSize} />
        </PressableNeolexon>
      );
    });
  };

  return <View style={styles.container}>{FeedbackComponents()}</View>;
}
